import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22font-family.js%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../assets/fonts/Inter-roman.var-subset.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22../assets/fonts/Inter-italic.var-subset.woff2%22,%22weight%22:%22400%22,%22style%22:%22italic%22},{%22path%22:%22../assets/fonts/Inter-roman.var-subset.woff2%22,%22weight%22:%22600%22,%22style%22:%22normal%22},{%22path%22:%22../assets/fonts/Inter-italic.var-subset.woff2%22,%22weight%22:%22600%22,%22style%22:%22italic%22}],%22variable%22:%22--font-text%22}],%22variableName%22:%22textFontLoader%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'textFontLoader', 'textFontLoader Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
